import React from 'react'
import StickerPage from './edit/StickerPage'

/**
 * The Edit page is the sticker page, for every project.
 *
 * The classic editor (container-in-container panels, a pixel size picker, the
 * brush always on) was retired on 2026-10-01. What a project offers is two
 * Studio toggles, Auto layout and Draw, with the old `stickerMode` read as
 * their fallback so every project keeps what its guests had
 * (`resolveEditStickerOptions`).
 */
const EditRoute: React.FC = () => <StickerPage />

export default EditRoute
